import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async () => ({
  redirect: {
    destination: '/admin/meetings/quick-call/new',
    permanent: false,
  },
});

export default function AdminQuickCallNewRedirect() {
  return null;
}
